import { RouterConfig } from './navigation/router-config'
import { BrowserRouter } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'
import { ConfirmProvider } from 'hic-components'
import React from 'react'
import { ApolloProvider } from '@apollo/client'
import useApolloClient from 'src/api/apollo-client/apollo-client.hook'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import useCurrentLocale from './hooks/current-locale/use-current-locale'
import { LicenseInfo } from '@mui/x-license-pro'
import { AuthProvider } from './hooks/auth/auth.context'
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns'
import { ContextProvider } from './hooks/context/context'
import { customTheme } from './components/hic-vapor/theme/hic-vapor-theme'
import { ThemeProvider } from '@mui/material'
import InsightPopupProvider from './components/insight-popup/insight-popup-provider'
import { CookiesSelector } from './components/cookies-selector/cookies-selector'
import i18n from 'src/locales/i18n'

document.documentElement.lang = i18n.language

// FA IN MODO CHE GLI ERRORI VISUALIZZATI IN OVERLAY VENGANO MOSTRATI SULLA CONSOLE (Gli errori in overlay sono stati disattivati tramite css)
window.addEventListener('error', function (e) {
  console.error(e.message)
  e.stopImmediatePropagation()
  e.preventDefault()
})

function App() {
  LicenseInfo.setLicenseKey('cb3e4f7fda3ad7c6f6e1acb600b9dd2aTz04NDE2NyxFPTE3Mzk0NDc5MjAwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y')

  // AuthProvider MUST be outsider AppProviders because the useApolloClient hook needs to
  // be inside the AuthContext to use the current token
  return (
    <AuthProvider>
      <AppProviders>
        <BrowserRouter>
          <RouterConfig />
        </BrowserRouter>
      </AppProviders>
    </AuthProvider>
  )
}

export default App

function AppProviders(props: { children: React.ReactNode }) {
  const apolloClient = useApolloClient()
  const { dateFnsLocale } = useCurrentLocale()

  if (apolloClient)
    return (
      <ApolloProvider client={apolloClient}>
        <ThemeProvider theme={customTheme}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={dateFnsLocale}>
            <ContextProvider>
              <SnackbarProvider maxSnack={3}>
                <ConfirmProvider>
                  <CookiesSelector>
                    <InsightPopupProvider>{props.children}</InsightPopupProvider>
                  </CookiesSelector>
                </ConfirmProvider>
              </SnackbarProvider>
            </ContextProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </ApolloProvider>
    )
  else return <></>
}
